import { Roles } from 'model';
import { useUserHasAllRoles, useUserHasSomeRoles } from '../hooks/useUserHasRole.js';
import React from 'react';

export type RequireRoleProps = {
	children: React.ReactNode;
	roles: Roles[];
	type: 'some' | 'all';
};

export function RequireRoles({ children, roles, type }: RequireRoleProps): JSX.Element | null {
	const hasAllRoles = useUserHasAllRoles(roles);
	const hasSomeRoles = useUserHasSomeRoles(roles);
	return (type === 'all' && hasAllRoles) || (type === 'some' && hasSomeRoles) ? <>{children}</> : null;
}
